import * as React from 'react';
import Link from '@mui/material/Link';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import { DataGrid } from '@mui/x-data-grid';
import Title from './Title';
import { useState, useEffect } from "react";

export default function Forms(props) {
  return (
    <React.Fragment>
      <Title>UTM Events</Title>
      <Table size="small">
        <TableHead>
          <TableRow>
            <TableCell>UTM</TableCell>
            <TableCell>Count</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {props.events.map((row, index) => (
            <TableRow key={index}>
              <TableCell>{row.utm}</TableCell>
              <TableCell>{row.count}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
      {/* <Link color="primary" href="#" onClick={preventDefault} sx={{ mt: 3 }}>
        See more events
      </Link> */}
    </React.Fragment>
  );
}